var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"adminHome"},[_c('device-nav',{attrs:{"deviceList":_vm.deviceList}}),(_vm.shownComponent)?_c(_vm.shownComponent,{tag:"component",staticClass:"article"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }